<template>
  <div :id="id" class="sc-tab" :class="{ 'selected' : this.isSelected }">
    <div class="content" v-if="this.isSelected">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScTab',
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    url: {
      type: String
    },
    id: {}
  },
  data () {
    return {
      selectedState: false
    }
  },
  mounted () {
    this.selectedState = this.selected
  },
  computed: {
    isSelected: {
      get () {
        return this.selectedState
      },

      set (selected) {
        this.selectedState = selected
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
